import { useEffect, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { fetchClient } from '../api/clients';
import type { ClientDetail, Env } from '../types';
import { ClientView } from '../components/ClientView';

export function ClientDetailPage() {
  const { uuid } = useParams<{ uuid: string }>();
  const [sp] = useSearchParams();
  const env = (sp.get('env') === 'staging' ? 'staging' : 'prod') as Env;

  const [client, setClient] = useState<ClientDetail | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!uuid) return;
    setLoading(true);
    setError(null);
    fetchClient(uuid, env)
      .then((r) => setClient(r.data))
      .catch((e) => setError((e as Error).message))
      .finally(() => setLoading(false));
  }, [uuid, env]);

  return (
    <div className="space-y-6">
      <Link to="/clients" className="t-link hover:underline text-sm">
        &larr; Vue client
      </Link>
      {loading && <div className="text-[13px] t-muted">Chargement...</div>}
      {error && !loading && <div className="text-red-400">{error}</div>}
      {!loading && !error && !client && <div className="text-[13px] t-muted">Client introuvable.</div>}
      {!loading && !error && client && <ClientView client={client} />}
    </div>
  );
}
